import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../data/translations';
import { MapPin, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a3a52] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_9bdc54da-c0a9-4aea-9bd3-e8f1cd139c29/artifacts/9iv1uh4i_WhatsApp%20Image%202026-03-23%20at%2010.59.17%20AM.jpeg"
              alt="Taj Gulf Trading LLC"
              className="h-12 w-auto object-contain bg-white p-2 rounded"
            />
            <h3 className="text-lg font-semibold text-[#c5a365]">{t('footer.about')}</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('footer.aboutText')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#c5a365]">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#c5a365] transition-colors text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#c5a365] transition-colors text-sm">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-[#c5a365] transition-colors text-sm">
                  {t('nav.products')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#c5a365] transition-colors text-sm">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#c5a365] transition-colors text-sm">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#c5a365]">{t('footer.contactInfo')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[#c5a365] flex-shrink-0 mt-0.5" />
                <a href="mailto:sales@tajgulfoman.com" className="text-gray-300 hover:text-[#c5a365] text-sm transition-colors">
                  sales@tajgulfoman.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#c5a365] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">Ruwi, Sultanate of Oman</span>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-[#c5a365] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">{t('contact.hoursText')}</span>
              </li>
            </ul>
          </div>

          {/* Business Stats */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#c5a365]">Our Achievements</h3>
            <div className="space-y-3">
              <div className="bg-white/10 p-3 rounded-lg">
                <p className="text-2xl font-bold text-[#c5a365]">30+</p>
                <p className="text-sm text-gray-300">{t('home.experienceLabel')}</p>
              </div>
              <div className="bg-white/10 p-3 rounded-lg">
                <p className="text-2xl font-bold text-[#c5a365]">200+</p>
                <p className="text-sm text-gray-300">{t('home.customersLabel')}</p>
              </div>
              <div className="bg-white/10 p-3 rounded-lg">
                <p className="text-2xl font-bold text-[#c5a365]">1000+</p>
                <p className="text-sm text-gray-300">{t('home.productsLabel')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Taj Gulf Trading LLC. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
